import React, { useEffect } from "react"
import PropTypes from "prop-types"
import useScript from "react-script-hook"
import useAxios from "axios-hooks"

import { iframelyApiKey } from "../../../../../config"

const Iframely = ({ url }) => {
  const [isScriptLoading, scriptLoadingError] = useScript({
    src: "//cdn.iframe.ly/embed.js",
  })
  const [{ data, loading: isContentLoading, contentLoadingError }] = useAxios({
    url: "https://iframe.ly/api/oembed",
    params: { url, api_key: iframelyApiKey, iframe: true, omit_script: true },
  })

  useEffect(() => {
    if (window.iframely && data !== null) {
      window.iframely.load()
    }
  }, [isScriptLoading, data])

  return isScriptLoading ||
    isContentLoading ||
    scriptLoadingError ||
    contentLoadingError ||
    data === null ? null : (
    <div dangerouslySetInnerHTML={{ __html: data.html }} />
  )
}

export default Iframely

Iframely.propTypes = {
  url: PropTypes.string.isRequired,
}
